import React, { useState } from "react";
import { Button, Drawer, Select } from "antd";
import { PartnerStoreModel } from "store/models/master-data/partner";
import SearchHelp from "Components/search-help";
import { isScreenMobile } from "Utils";
import PartnerForm from "Pages/private/master-data/partners/components/form";
import { AuthCheck, AUTH_ACTIONS } from "authorization";
import { useStoreState } from "easy-peasy";
import { DISPLAY_MODE } from "Constants";

export default function PartnerSelect({
  form,
  field,
  params,
  defaultValue,
  objectInValue = true,
  placeholder,
  ...props
}) {
  const { abilities } = useStoreState((store) => store.auth);
  const [_defaultValue, setDefaultValue] = useState(defaultValue);
  const [formVisibility, setFormVisibility] = useState(false);
  return (
    <>
      <SearchHelp
        {...props}
        form={form}
        field={field}
        defaultValue={_defaultValue}
        objectInValue={objectInValue}
        model={PartnerStoreModel}
        params={params}
        notFoundContent={
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <span>Kayıt Bulunamadı</span>
            {AuthCheck(abilities, AUTH_ACTIONS.NEW_RECORD, "Muhataplar") && (
              <Button
                style={{ margin: 20 }}
                onClick={() => setFormVisibility(true)}
              >
                Yeni
              </Button>
            )}
          </div>
        }
        searchParam="fastSearchParam"
        placeholder="Ara: Ad, Soyad, E-Posta"
        optionTemplate={(item) => {
          return (
            <Select.Option key={item?.id} value={item?.id}>
              {`${item?.name} ${item?.surname || ""}`}
              <br />
              {`${item?.identityNumber}/${item?.taxOffice || ""}`}
              <br />
              {`${item?.email || ""}`}
            </Select.Option>
          );
        }}
      />
      <Drawer
        width={isScreenMobile() ? "90%" : "50%"}
        placement="right"
        bodyStyle={{
          overflowY: "auto",
          height: "100%",
          backgroundColor: "#f2f2f2",
          padding: 0,
        }}
        destroyOnClose={true}
        title="Yeni Muhatap"
        visible={formVisibility}
        onClose={() => setFormVisibility(false)}
      >
        <PartnerForm
          mode={DISPLAY_MODE.NEW}
          partner={{
            address: null,
            birthPlace: null,
            civilServantOther: null,
            contractBlockade: false,
            dateOfApprovalKinderGarten: null,
            dateOfBirth: null,
            email: null,
            fax: null,
            gender: null,
            identityNumber: null,
            name: null,
            partnerRoles: [],
            partnerTask: null,
            phone: null,
            profession: null,
            relations: [],
            surname: null,
            taskDistinctionTitle: null,
            taxOffice: null,
            timeOfJobFinish: null,
            timeofJobBeginning: null,
            title: null,
          }}
          onAfterSuccess={(response) => {
            setDefaultValue(response);
            form.setValue(field, response);
            setFormVisibility(false);
          }}
        />
      </Drawer>
    </>
  );
}
